module.exports = __webpack_public_path__ + "static/img/logo1.3659ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo1.png
// module id = /IIA
// module chunks = 1